<template>
  <modal id="updateInvoice" v-cloak>
    <div slot="title">
      <h4>Pas de factuur aan</h4>
    </div>
    <div slot="body">
      <form class="justify-content-between col-sm-12 py-3">
        <p class="col-sm-12 font-weight-bold">Factuurgegevens
        </p>
        <div class="form-row align-items-center py-3">
          <DateInputField
              class="form-group col-sm-6" v-model="selectedInvoice.invoiceDate"
              labelText="factuurdatum" required/>
          <NumberInputField
              class="form-group col-sm-6" v-model="selectedInvoice.vatpercentage"
              labelText="BTW-percentage" required/>
          <TextInputField
              class="form-group col-sm-6" email v-model="selectedInvoice.contactMail"
              labelText="e-mail voor contact" required/>
          <div class="form-group col-lg-6">
            <label>E-mail(s) voor facturatie</label>
            <multiselect
                v-model="selectedInvoice.confirmedEmailDtos"
                :options="confirmedEmails"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Selecteer één of meerdere"
                label="emailAddress"
                track-by="emailAddress"
                :preselect-first="true">
            </multiselect>
          </div>
        </div>

        <p class="col-sm-12 font-weight-bold">Klantgegevens</p>
        <div class="form-row align-items-center py-3">
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.organisationName"
              labelText="organisatienaam"
              minLength="2" maxLength="40" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.financialSupervisorReference"
              labelText="aangeschrevene"
              minLength="2" maxLength="40" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.street"
              labelText="straat" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.houseNumber"
              labelText="huisnummer" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.postalCode"
              labelText="postcode" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.city"
              labelText="stad" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.country"
              labelText="land" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.customerBillingDto.vat"
              labelText="BTW-nummer" required
              minLength="3" maxLength="40"/>
          <div class="form-group col-sm-12">
            <label>Betalingstermijn</label>
            <select v-model="selectedInvoice.customerBillingDto.paymentTerm" class="form-control">
              <option :value="null" disabled>Kies een betalingstermijn</option>
              <option v-for="dropdownElement in paymentTermOptions"
                  :key="dropdownElement.id"
                  :value="dropdownElement.value">{{ dropdownElement.value }} dagen
              </option>
            </select>
          </div>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.internalReference"
              labelText="interne referentie" required/>
          <TextInputField
              class="form-group col-sm-6" v-model="selectedInvoice.externalReference"
              labelText="externe referentie" required/>
          <TextInputField
              class="form-group col-sm-12" v-model="selectedInvoice.disclaimer"
              labelText="disclaimer" required/>
        </div>

        <div class="row col-16 mt-5 justify-content-start">
          <h4 class="mt-3">Vrije Kosten</h4>
        <table class="table b-table-fixed">
          <thead class="thead-dark">
            <tr>
              <th scope="col" class="col-md-2">Omschrijving</th>
              <th scope="col" class="col-md-2">Aantal</th>
              <th scope="col" class="col-md-2">Eenheden</th>
              <th scope="col" class="col-md-2">Kost</th>
              <th scope="col" class="col-md-2">Type</th>
              <th scope="col" class="col-md-2">Totaal</th>
              <th scope="col" class="col-md-2">Actie</th>
            </tr>
          </thead>
          <tbody>
          <template v-for="(freeCostDto,index) in selectedInvoice.freeCosts">
            <tr :key="freeCostDto" class="col-md-16">
              <td class="col-md-2">
                <TextInputField
                    class="form-group"
                    v-model="freeCostDto.description"
                    labelText="Omschrijving"
                    hide-label=true
                    required
                    minLength="1"
                    maxLength="255"/>
              </td>

              <td class="col-md-2">
                <NumberInputField
                    class="form-group"
                    v-model="freeCostDto.amount"
                    labelText="Aantal"
                    hide-label=true
                    required
                    maxLength="40"/>
              </td>

              <td class="col-md-2">
                <TextInputField
                    class="form-group"
                    v-model="freeCostDto.units"
                    labelText="Eenheden"
                    hide-label=true
                    required
                    minLength="1"
                    maxLength="40"/>
              </td>

              <td class="col-md-2">
                <NumberInputField
                    class="form-group"
                    v-model="freeCostDto.cost"
                    labelText="Kost"
                    hide-label=true
                    required
                    maxLength="40"/>
              </td>

              <td class="col-md-2">
                <div id="selector" class="form-group">
                  <select v-model="freeCostDto.accountingCost" class="form-control">
                    <option value="" disabled selected>Selecteer type kost</option>
                    <option v-bind:key="accountingCost.billingCode" v-bind:value="accountingCost" v-for="accountingCost in accountingCosts" >
                      {{ accountingCost.name }}
                    </option>
                  </select>
                </div>

              </td>
              <td class="col-md-2">{{ freeCostDto.cost * freeCostDto.amount }}</td>

              <td class="col-md-2">
                <div class="d-flex align-items-center">
                  <button class="btn btn-fill-pulse-dark m-0" @click="deleteFreeCost(index)">{{  'Verwijderen' }}</button>
                </div>
              </td>
            </tr>
          </template>
        </tbody>

        </table>
          <button  @click="addFreeCostToInvoice" class="btn-basic btn-fill-pulse">Toevoegen</button>
        </div>
      </form>
    </div>
    <div slot="footer">
      <button
          type="button" class="btn-basic btn-green mr-2 my-2"
          :disabled="!changesMade  || !canSaveFreeCost"
          @click="handleSaveButton">Opslaan</button>
      <button
          type="button" class="btn-basic btn-red mr-2 my-2"
          @click="handleReturnButton">Annuleren</button>
    </div>
  </modal>
</template>

<script>
import {VoerroModal} from "@voerro/vue-modal";
import DateInputField from "@/components/inputFields/DateInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";
import TextInputField from "@/components/inputFields/TextInputField";
import {mapActions, mapGetters, mapMutations} from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "UpdateInvoiceModal",
  components: {
    Multiselect,
    DateInputField,
    NumberInputField,
    TextInputField
  },
  data: () => ({
    paymentTermOptions: [{"id": 1, "value": 30}, {"id": 2, "value": 60}, {"id": 3, "value": 90}],
    editingIndex: -1,
    freeCostDescription: "",
    freeCostAmount: 0,
    freeCostUnits: "",
    freeCost: 0,
    showCreateFreeCost: false,
    originalInvoice: null,
    selectedEmails: []
  }),
  computed: {
    ...mapGetters({
      stateInvoice: "administrationInvoice/selectedInvoice",
      accountingCosts: "administrationInvoice/accountingCosts",
      confirmedEmails: "administrationInvoice/confirmedEmails"
    }),
    ...mapMutations({
      setSelectedInvoice: "administrationInvoice/setSelectedInvoice",
    }),
    selectedInvoice: {
      set(invoice) {
        this.$store.commit("setSelectedInvoice", { invoice });
      },
      get() {
        return this.stateInvoice;
      }
    },
    changesMade() {
      return JSON.stringify(this.selectedInvoice) !== JSON.stringify(this.originalInvoice);
    },
    canSaveFreeCost() {
      return this.selectedInvoice.freeCosts.every(freeCost => {
        return this.isTextInputValid(freeCost.description) &&
            this.isNumberInputValid(freeCost.amount) &&
            this.isTextInputValid(freeCost.units) &&
            this.isNumberInputValid(freeCost.cost) &&
            freeCost.accountingCost!== "";
      });
    },
  },
  created() {
    this.storeUnchangedInvoice();
    this.fetchAccountingCostsList();
    this.fetchConfirmedEmailsList();
  },
  methods: {
    ...mapActions("administrationInvoice", ["updateInvoice","fetchInvoiceById","fetchAccountingCostsList", "fetchConfirmedEmailsList"]),
    storeUnchangedInvoice() {
      this.originalInvoice = JSON.parse(JSON.stringify(this.selectedInvoice));
    },
    isTextInputValid(text) {
      return text.trim().length > 0;
    },
    isNumberInputValid(number) {
      return number > 0;
    },
    handleReturnButton() {
      var closeUpdateModal = true;
      if (this.changesMade) {
        closeUpdateModal = window.confirm("U heeft niet-opgeslagen wijzigingen. Weet u zeker dat u ze wilt verwijderen?");
      }
      if (closeUpdateModal){
        this.fetchInvoiceById(this.selectedInvoice.id);
        VoerroModal.hide("updateInvoice");
      }
    },

    handleSaveButton() {
      this.updateInvoice();
      VoerroModal.hide("updateInvoice");
    },
    toggleCreateFreeCost() {
      this.showCreateFreeCost = !this.showCreateFreeCost;
      event.preventDefault();
    },
    addFreeCostToInvoice() {
      const freeCost = {
        description: "",
        amount: 0,
        units: "",
        cost: 0,
        accountingCost: ""
      };
      this.selectedInvoice.freeCosts.push(freeCost);
      event.preventDefault();
    },
    deleteFreeCost(index) {
      this.selectedInvoice.freeCosts.splice(index,1);
      event.preventDefault();
    }
  }
};
</script>

<style scoped>

</style>